import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Space, Row, Col, Modal, Tooltip } from 'antd';
import { PlusOutlined, DeleteOutlined, DragOutlined } from '@ant-design/icons';

const SpecificationGroup = ({ fields, add, remove, errors }) => {
    return (
        <Card
            key={fields.key}
            style={{
                marginBottom: 24,
                borderRadius: 8
            }}
            bodyStyle={{ padding: 0 }}
        >
            <div style={{ 
                padding: 16,
                backgroundColor: 'rgb(247 252 255)',
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Form.Item
                        {...fields}
                        name={[fields.name, 'heading']}
                        rules={[
                            { required: true, message: ' ' },
                            { max: 50, message: 'Heading cannot exceed 50 characters' }
                        ]}
                        style={{ marginBottom: 0, flex: 1 }}
                        validateTrigger={['onBlur', 'onSubmit']}
                    >
                        <Input 
                            placeholder="Group Heading (e.g., Technical Specifications, Physical Details)" 
                            style={{ fontSize: '16px' }}
                            prefix={<DragOutlined style={{ color: '#bfbfbf' }} />}
                        />
                    </Form.Item>
                    <Tooltip title="Remove Group">
                        <Button
                            type="text"
                            danger
                            icon={<DeleteOutlined />}
                            onClick={() => {
                                Modal.confirm({
                                    title: 'Remove Specification Group',
                                    content: 'Are you sure you want to remove this group? This action cannot be undone.',
                                    okText: 'Yes, Remove',
                                    okType: 'danger',
                                    cancelText: 'No, Keep',
                                    onOk: () => remove(fields.name)
                                });
                            }}
                        />
                    </Tooltip>
                </div>
            </div>

            <div style={{ padding: 16 }}>
                <Form.List name={[fields.name, 'fields']}>
                    {(subFields, { add: addField, remove: removeField }) => (
                        <>
                            {subFields.map(({ key: subKey, name: subName, ...subRestField }) => (
                                <div key={subKey} style={{ 
                                    display: 'flex', 
                                    gap: 16, 
                                    marginBottom: 16,
                                    alignItems: 'center'
                                }}>
                                    <Form.Item
                                        {...subRestField}
                                        name={[subName, 'key']}
                                        rules={[
                                            { required: true, message: ' ' },
                                            { max: 30, message: 'Field name cannot exceed 30 characters' }
                                        ]}
                                        style={{ flex: 1, marginBottom: 0 }}
                                        validateTrigger={['onBlur', 'onSubmit']}
                                    >
                                        <Input 
                                            placeholder="Field Name (e.g., Brand, Model, Year)" 
                                            style={{ width: '100%' }}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        {...subRestField}
                                        name={[subName, 'value']}
                                        rules={[
                                            { required: true, message: ' ' },
                                            { max: 100, message: 'Field value cannot exceed 100 characters' }
                                        ]}
                                        style={{ flex: 1, marginBottom: 0 }}
                                        validateTrigger={['onBlur', 'onSubmit']}
                                    >
                                        <Input 
                                            placeholder="Field Value (e.g., Apple, iPhone 13, 2023)" 
                                            style={{ width: '100%' }}
                                        />
                                    </Form.Item>
                                    <Tooltip title="Remove Field">
                                        <Button
                                            type="text"
                                            danger
                                            icon={<DeleteOutlined />}
                                            onClick={() => removeField(subName)}
                                        />
                                    </Tooltip>
                                </div>
                            ))}
                            <Button
                                type="dashed"
                                onClick={() => addField()}
                                block
                                icon={<PlusOutlined />}
                                style={{ marginTop: 8 }}
                            >
                                Add Field
                            </Button>
                        </>
                    )}
                </Form.List>
            </div>
        </Card>
    );
};

export default SpecificationGroup; 